import taskManagerApi from '@/features/shared/services/taskManagerApi';
export const fetchPriorities = async () => {
    try {
        const response = await taskManagerApi.get(`/priority`);
        return response.data.data; // Renvoie uniquement la liste des états
    }
    catch (error) {
        console.error('Erreur lors de la récupération des priorités :', error);
        throw error;
    }
};
export const handleAddPriority = async (priority) => {
    try {
        await taskManagerApi.post("/priority", priority);
        console.log(`La priorité ${priority.label} a été ajouté avec succès.`);
    }
    catch (error) {
        console.error("Erreur lors de l'ajout de la priorité :", error);
    }
};
export const handleUpdatePriority = async (priority) => {
    try {
        await taskManagerApi.put(`/priority/${priority.id}`, priority);
        console.log(`La priorité ${priority.label} a été modifié avec succès. : `, priority);
    }
    catch (error) {
        console.error("Erreur lors de la modification de la priorité :", error);
    }
};
export const handleDeleteSPriority = async (id) => {
    try {
        await taskManagerApi.delete(`/priority/${id}`);
        console.log(`La priorité ${id} a été supprimé avec succès.`);
    }
    catch (error) {
        console.error("Erreur lors de la suppression de la priorité :", error);
    }
};
